module.exports = __webpack_public_path__ + "static/media/lea_img_01.13f02210.jpg";